<template>
    <div>
        <internal-header heading="Batches" :show-button="true" :button-link="importWorkingDues" button-text="Import Batch" />
        <smart-table
            id="batches_list"
            class="row-pointer"
            endpoint="batches.list"
            :headers="headers"
            :search="search"
            :multi-sort="true"
            :items-per-page="20"
            :display_fields="displayed_column_names"
            :footer-props="{
                'items-per-page-options': [5, 10, 20, 30]
            }"
            flat
            @click:row="showBatchItem"
            ref="batches_list"
        >
            <template v-slot:item.id="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.payer="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.date_deposit="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.currency="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.conversion_rate="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.method="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.date_import="{ isMobile, item, header, value, index}">
                {{ value }}
            </template>
            <template v-slot:item.export="{ isMobile, item, header, value, index}">
                <v-icon
                    v-show="item.creation_complete"
                    :loading="exportLoading"
                    @click.stop="exportBatch(item)">
                    mdi-export-variant
                </v-icon>
                <v-progress-circular
                    v-show="!item.creation_complete"
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </template>
            <template v-slot:item.delete="{ isMobile, item, header, value, index}">
                <v-icon
                    :loading="archiveLoading"
                    @click.stop="deleteBatch(item)">
                    mdi-delete-outline
                </v-icon>
            </template>
        </smart-table>


        <import-batch-dialog
            v-model="importBatchDialog"
            :constants="constants"
        ></import-batch-dialog>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader";
    import ImportBatchDialog from "./Dialogs/ImportBatchDialog.vue";

    export default {
        name: "BatchesIndex",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            SmartTable,
            InternalHeader,
            ImportBatchDialog,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                search: null,
                archiveLoading: false,
                exportLoading: false,
                batchSelected: {},
                importBatchDialog: false,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'id',                 text: 'Batch ID',                   align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'payer',              text: 'Payer',                      align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'date_deposit',       text: 'Deposit Date',               align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'currency',           text: 'Currency',                   align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'conversion_rate',    text: 'Conversion Rate',            align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'method',             text: 'Method',                     align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'date_import',        text: 'Import Date',                align: `start`, sortable: true,    filterable: false,  optional: false, },
                    {value: 'export',             text: '',                           align: `start`, sortable: false,   filterable: false,  optional: false, },
                    {value: 'delete',             text: '',                           align: `start`, sortable: false,   filterable: false,  optional: false, },
                ]
            },
            displayed_column_names() {
                let headers_to_display = this.headers.filter(header => this.should_column_be_displayed(header.value))
                return headers_to_display.map(header => header.value)
            },
        },
        methods: {
            should_column_be_displayed(column) {
                let required_headers = ['id', 'payer', 'date_deposit', 'currency', 'conversion_rate', 'method', 'date_import', 'export', 'delete']
                return required_headers.includes(column)
            },
            refreshBatchData() {
                this.$refs.batches_list.refreshList()
            },
            showBatchItem(batch) {
                if (batch.creation_complete) {
                    this.$inertia.visit(route('batches.show', batch.id))
                } else {
                    this.$root.snackbar.error('This batch is still being processed.  Please try again later.')
                }
            },
            importWorkingDues() {
                this.importBatchDialog = !this.importBatchDialog
            },
            async exportBatch(item) {
                if (await this.$root.confirm.open(`Export Batch`, `You are about to export Batch #${item.id}`)) {
                    let method = 'post'
                    let url = route('batches.export')
                    let payload = item

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.exportLoading = !this.exportLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.exportLoading = !this.exportLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the export once it is done.`)
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.exportLoading = false
                                this.$emit('successful-batch-export')
                            } else {
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response?.data.message || error)
                            this.exportLoading = false
                        })
                }
            },
            async deleteBatch(item) {
                if (await this.$root.confirm.open(`Delete Batch`, `You are about to delete Batch #${item.id}`)) {
                    let method = 'delete'
                    let url = route('batches.destroy', item.id)
                    let payload = item

                    axios({
                        method: method,
                        url: url,
                        data: payload,
                        onUploadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                        onDownloadProgress: (evt) => {
                            this.archiveLoading = !this.archiveLoading
                        },
                    })
                        .then(response => {
                            if (response.data.success) {
                                this.$root.is_dirty = false
                                this.$root.snackbar.success('Batch has been deleted')
                                this.dialog = false
                                this.$root.is_dirty = false
                                this.archiveLoading = false
                                this.$emit('successful-batch-delete')
                                this.refreshBatchData()
                            } else {
                                this.$root.snackbar.error(response.data.error)
                                throw (response.data.error)
                            }
                        })
                        .catch((error) => {
                            this.$root.snackbar.error(error.response.data.message)
                            this.archiveLoading = false
                        })
                }
            },
        }
    }
</script>

<style >
.row-pointer tbody tr {
    cursor: pointer;
}
</style>
